/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Report_Formheading1Inputs */

const ja_playdata_report_formheading1 = /** @type {(inputs: Playdata_Report_Formheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お申込みフォーム`)
};

const en_playdata_report_formheading1 = /** @type {(inputs: Playdata_Report_Formheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request Form`)
};

/**
* | output |
* | --- |
* | "Request Form" |
*
* @param {Playdata_Report_Formheading1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_report_formheading1 = /** @type {((inputs?: Playdata_Report_Formheading1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Report_Formheading1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_report_formheading1(inputs)
	return en_playdata_report_formheading1(inputs)
});
export { playdata_report_formheading1 as "playdata_report_formHeading" }